import { get } from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Leaderboard, PrizeInfo, Race } from '@swf/casino';
import Counter from '@swf/components/Counter/Counter';
import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { Dispatch } from '@swf/core/store';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';
import { isLeaderboard } from '@swf/core/utils/casino';

import styles from './CasinoRaceLeaderboard.scss';

interface CasinoRaceLeaderboardParams {
  race: CasinoRace;
  widgetId: string;
  path: string;
}

const CasinoRaceLeaderboard: React.FC = () => {
  const { race, widgetId, path } = useSearchParams<CasinoRaceLeaderboardParams>();
  const { modal } = useDispatch<Dispatch>();
  const { widgetSelect } = useWidget(widgetId);
  const data = useSelector(widgetSelect?.get);
  const myRace: CasinoRace = race || get(data, path);
  const { leaderboard, name, status } = myRace;
  const standings = leaderboard || [];

  return (
    <div className={styles.leaderboard}>
      <Header className={styles.header}>
        {name}
        <CloseButton variant={Variant.Light} />
      </Header>
      <div className={styles.raceContainer}>
        <Counter>
          {(count) => (
            <Race
              count={count}
              race={myRace}
              onLaunch={() => modal.close()}
              widgetId={widgetId}
              path={`${path}`}
            />
          )}
        </Counter>
      </div>
      <PrizeInfo prizeDetails={myRace.prizeDetails} />
      <Leaderboard
        race={myRace}
        className={styles.table}
        leaderboard={isLeaderboard(status)}
        standings={standings}
      />
    </div>
  );
};

export default CasinoRaceLeaderboard;
